import { ApiPickupLocation } from '../api';

export interface AppPickupLocation {
    pickupLocationId: string;
    pickupLocationName: string;
    companyUniqueId: string | null;
    isActive: boolean | null;
    createdDate: string | null;
    createdBy: string | null;
    lastModifiedDate: string | null;
    lastModifiedBy: string | null;
    latitude: number | null;
    longitude: number | null;
    mapFilePath: string | null;
    mapAddress: string | null;
    defaultForNotArrivingByCruise: boolean | null;
    defaultForArrivingByCruise: boolean | null;
}

export function fromApiPickupLocations(
    pickupLocations: ApiPickupLocation[]
): AppPickupLocation[] {
    return pickupLocations.map((pickupLocation) =>
        fromApiPickupLocation(pickupLocation)
    );
}

export function fromApiPickupLocation(
    pickupLocation: ApiPickupLocation
): AppPickupLocation {
    return {
        pickupLocationId: pickupLocation.PickupLocationID,
        pickupLocationName: pickupLocation.PickupLocationName,
        companyUniqueId: pickupLocation.CompanyUniqueId,
        isActive: pickupLocation.IsActive,
        createdDate: pickupLocation.CreatedDate,
        createdBy: pickupLocation.CreatedBy,
        lastModifiedDate: pickupLocation.LastModifiedDate,
        lastModifiedBy: pickupLocation.LastModifiedBy,
        latitude: pickupLocation.latitude,
        longitude: pickupLocation.longitude,
        mapFilePath: pickupLocation.MapFilePath,
        mapAddress: pickupLocation.MapAddress,
        defaultForNotArrivingByCruise:
            pickupLocation.DefaultForNotArrivingByCruise,
        defaultForArrivingByCruise: pickupLocation.DefaultForArrivingByCruise,
    };
}
